import { render } from "./FormGeneralDEV.vue?vue&type=template&id=607e2ea2"
import script from "./FormGeneralDEV.vue?vue&type=script&lang=js"
export * from "./FormGeneralDEV.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__